import { mapActions, mapGetters } from 'vuex';
import { TAB_KEYS } from '@/helpers/constants';
export default {
  data () {
    return {
      exitMeetingInQueue: false,
      meetingAuthSuccess: false
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      inMeeting: 'inMeeting',
      inPhoneCall: 'inPhoneCall'
    })
  },
  methods: {
    ...mapActions('AppStore', {
      setActiveTab: 'setActiveTab',
      setOrientation: 'setOrientation',
      setInPhoneCallStatus: 'setInPhoneCallStatus'
    }),
    checkForUpdate () {
      const needUpdate = false;
      // var version = this.deviceInfo.appVersion;
      // if (!version) {
      //   needUpdate = true;
      // } else {
      //   var storeVersion =
      //     this.$_CONFIG.appconfig.ANDROID_CAMERA_APP_LATEST || '1';
      //   if (parseInt(storeVersion) > parseInt(version)) {
      //     needUpdate = true;
      //   }
      // }
      return needUpdate;
    },
    goBack () {
      this.$router.back();
    },
    onChatNotificationClick (info) {
      this.setActiveTab(TAB_KEYS.CHATS);
    },
    onMissedCallClick (info) {
      this.setActiveTab(TAB_KEYS.RECENT);
    },
    onDialToNumber ({ room }) {
      if (this.user) {
        this.onShowOutgoingCall({
          room,
          presence: true,
          userstatus: 1
        });
      } else {
        this.$eventBus.$emit('goto-webrtc-page', {
          room,
          presence: true,
          userstatus: 1
        });
      }
    },
    onExitMeeting (data) {
      this.sendToControls({
        type: 'task',
        scope: 'app',
        data: {
          task: 'onExitMeeting',
          param: data
        }
      });
      this.meetingInitiated = false;
      if (this.meetingAuthSuccess) {
        this.onMeetingSocketDisconnected(data);
      } else {
        this.exitMeetingInQueue = true;
        if (this.inMeeting) {
          if (data && data.type === 'rejectcall') {
            let status = { callstatus: 'rejected' };
            if (data.reason === -1013) {
              status = { callstatus: 'locked' };
            }
            this.updateOutgoingContact(status);
          }
        }
      }
    },
    onGoBack () {
      if (this.inMeeting || this.showOutgoing || this.showIncoming) {
        // do nothing
      } else if (this.showContactInfo) {
        this.hideContact();
      } else if (this.noInternet) {
        this.$_NATIVE.exitApp();
      } else {
        // if (
        //   this.currentRoute.route.name === 'home' ||
        //   this.currentRoute.route.name === 'landing'
        // ) {
        //   this.$eventBus.$emit('btn-goBack');
        // } else {
        this.goBack();
        // }
      }
    },
    onMeetingAuthSuccess (status) {
      if (status && this.exitMeetingInQueue) {
        this.$_NATIVE.exitMeeting();
        if (this.inMeeting) {
          this.goBack();
          this.onRemoveCallingScreen({ noDelay: !!this.user, enableAutoRotate: false });
        }
        this.exitMeetingInQueue = false;
      }
      this.meetingAuthSuccess = status;
    },
    onMeetingSocketDisconnected (data) {
      this.$_NATIVE.exitMeeting();
      this.onMeetingAuthSuccess(false);
      if (this.inMeeting) {
        this.goBack();
        if (data && data.type === 'rejectcall') {
          let status = { callstatus: 'rejected' };
          if (data.reason === -1013) {
            status = { callstatus: 'locked' };
          }
          this.updateOutgoingContact(status);
        }
        this.onRemoveCallingScreen({ noDelay: false, enableAutoRotate: false });
      }
    },
    onNetworkChange (status) {
      this.noInternet = !status;
    },
    async onOrientationChange (orientation) {
      await this.setOrientation(orientation);
    },
    async onPhoneCallStatus ({ status }) {
      await this.setInPhoneCallStatus(status || false);
      this.$eventBus.$emit('phone-call-status');
    },
    onQRCodeScan (key) {
      this.$refs.presenceServer.qrAuthenticate(key);
    },

    initialVerification (startup = true) {
      this.appUpdateAvaliable = this.checkForUpdate();
      if (!this.appUpdateAvaliable) {
        if (this.authToken) {
          this.validateToken(startup);
        } else {
          this.gotoLanding();
        }
      }
    },
    async onSetDeviceInfo (deviceInfo) {
      await this.$store.dispatch('AppStore/setDeviceInfo', deviceInfo, {
        root: true
      });
      this.initialVerification();
    },
    onPushNotification (data) {
      if (data && this.user && this.user.userhash) {
        switch (data.type) {
          case 'call':
            if (this.user.userhash === data.myHash) {
              this.showIncomingCall(data);
            }
            break;
          case 'endcall':
            this.onCallEnd(data);
            break;
          case 'accepted':
            this.oncallAccepted(data, false);
            break;
          case 'rejected':
            this.onCallRejected(data);
            break;
          case 'self':
            this.removeIncomingCall({
              callstatus: 'self'
            });
            break;
          case 'conversation':
            if (this.$_GLOBAL.CHAT_ENABLED) {
              let message = null;
              try {
                message = JSON.parse(data.data);
              } catch (error) {
                message = null;
              }
              if (message) {
                this.onConversation(message);
              }
            }
            break;
        }
      }
    },
    onStandBy (mode) {
      this.setStandBy(!!mode);
    },
    removeIncomingCall ({ callstatus }) {
      if (this.showIncoming) {
        this.$eventBus.$emit('incoming-call-end', { callstatus });
      }
    },
    showIncomingCall (data) {
      this.setStandBy(false);
      if (
        this.inPhoneCall ||
        this.inMeeting ||
        this.showOutgoing ||
        this.showIncoming
      ) {
        this.$eventBus.$emit('call-reject', {
          room: data.room,
          callid: data.callId,
          reason: 'busy'
        });
      } else {
        this.$eventBus.$emit('show-incoming-call');
        this.sendToControls({
          type: 'task',
          scope: 'app',
          data: {
            task: 'showIncomingCall',
            param: data
          }
        });
        this.setIncomingContact({
          callId: data.callId || data.callid,
          displayName: data.displayName || data.displayname || '',
          profilepic: data.displayPic || data.displaypic || null,
          room: data.room,
          fromid: data.fromid,
          meetToken: data.meetToken || data.meettoken || null,
          protocol: data.protocol
        });
        this.showIncoming = true;
        this.exitMeetingInQueue = false;
      }
    },
    subscribeDeviceEvents () {
      this.$eventBus.$on('native-exitMeeting', this.onExitMeeting);
      this.$eventBus.$on('native-goBack', this.onGoBack);
      this.$eventBus.$on('native-meetingAuthSuccess', this.onMeetingAuthSuccess);
      this.$eventBus.$on('native-meetingSocketDisconnected', this.onMeetingSocketDisconnected);
      this.$eventBus.$on('native-networkChange', this.onNetworkChange);
      this.$eventBus.$on('native-onChatClick', this.onChatNotificationClick);
      this.$eventBus.$on('native-onMissedCallClick', this.onMissedCallClick);
      this.$eventBus.$on('native-onDialToNumber', this.onDialToNumber);
      this.$eventBus.$on('native-onPhoneCall', this.onPhoneCallStatus);
      this.$eventBus.$on('native-setDeviceInfo', this.onSetDeviceInfo);
      this.$eventBus.$on('native-onScanSuccess', this.onQRCodeScan);
      this.$eventBus.$on('native-onPushNotification', this.onPushNotification);
      this.$eventBus.$on(
        'native-onOrientationChange',
        this.onOrientationChange
      );
      this.$eventBus.$on('native-standBy', this.onStandBy);
      this.$eventBus.$on('try-validation', this.initialVerification);
    },
    unsubscribeDeviceEvents () {
      this.$eventBus.$off('native-exitMeeting', this.onExitMeeting);
      this.$eventBus.$off('native-goBack', this.onGoBack);
      this.$eventBus.$off('native-meetingAuthSuccess', this.onMeetingAuthSuccess);
      this.$eventBus.$off('native-meetingSocketDisconnected', this.onMeetingSocketDisconnected);
      this.$eventBus.$off('native-networkChange', this.onNetworkChange);
      this.$eventBus.$off('native-onChatClick', this.onChatNotificationClick);
      this.$eventBus.$off('native-onMissedCallClick', this.onMissedCallClick);
      this.$eventBus.$off('native-onDialToNumber', this.onDialToNumber);
      this.$eventBus.$off('native-onPhoneCall', this.onPhoneCallStatus);
      this.$eventBus.$off('native-setDeviceInfo', this.onSetDeviceInfo);
      this.$eventBus.$off('native-onScanSuccess', this.onQRCodeScan);
      this.$eventBus.$off('native-onPushNotification', this.onPushNotification);
      this.$eventBus.$off(
        'native-onOrientationChange',
        this.onOrientationChange
      );
      this.$eventBus.$off('native-standBy', this.onStandBy);
      this.$eventBus.$off('try-validation', this.initialVerification);
    }
  }
};
